import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FoodComponent } from '../food/food.component';
import { ActivitiesComponent } from '../activities/activities.component';
import { MobilityComponent } from '../mobility/mobility.component';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { UIComponentsModule } from 'src/app/shared/ui-components/ui-components.module';

@Component({
  selector: 'app-entry',
  imports: [
    FoodComponent,
    MobilityComponent,
    MatTabsModule,
    UIComponentsModule,
    ActivitiesComponent,
  ],
  templateUrl: './entry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './entry.component.scss',
})
export class EntryComponent {
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;

  @Input() selectedDate!: Date;

  tabStates = {
    food: { completed: false, active: true },
    mobility: { completed: false, active: false },
    activity: { completed: false, active: false },
  };

  onFoodContinue() {
    this.tabStates.food.completed = true;
    this.tabStates.mobility.active = true;
    this.tabGroup.selectedIndex = 1;
  }

  onMobilityContinue() {
    this.tabStates.mobility.completed = true;
    this.tabStates.activity.active = true;
    this.tabGroup.selectedIndex = 2;
  }

  onActivityContinue() {
    console.log('All entries completed!');
  }
}
